import React, { useState, useEffect, useRef } from 'react'
import Print from '../../../Common_Files/Print';
import { Host } from '../../../App';
import Axios from 'axios'
function Scrap({ partDataset, AllColumns, Area }) {

  var token = (window.localStorage.getItem("acessToken"));
  var userName = (window.localStorage.getItem("Name").replace(/[{""}]/g, ""));
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);
  const [Inventory_Date, setInventory_Date] = useState(currentDate.toISOString().slice(0, 10));

  var [Date1, setDate1] = useState(new Date());
  var [Postartdate, setPoStartdate] = useState(Date1.toISOString().slice(0, 10));
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  const [filterText, setFilterText] = useState({ customer: '', desc: '' });
  const [allParts, setAllParts] = useState([]);
  const [Scrap_Parts, setScrap_Parts] = useState([]);
  const tableRef = useRef(null);
  const [printTrigger, setPrintTrigger] = useState(false);
  const [History, setHistory] = useState(true);
  const handlePrint = () => {
    const tableHTML = tableRef.current?.innerHTML;
    setPrintTrigger({ html: tableHTML });
  };
  const [del, setdel] = useState(0);

  const [filteredParts, setfilteredParts] = useState([]);
  useEffect(() => {
    const initializeParts = () => {
      const savedData = localStorage.getItem('ScrapunsavedPartsData');

      let parts;
      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);

          parts = partDataset
            .map(part => {
              const savedMatch = parsed.find(p => p.Part_internalNo === part.Part_internalNo);
              return savedMatch
                ? { ...part, ...savedMatch }
                : { ...part, Scrap: part.Scrap || '', User: userName };
            });
        } catch (err) {
          console.error("Error parsing saved data", err);
          localStorage.removeItem('ScrapunsavedPartsData');
          parts = [];
        }
      } else {
        parts = partDataset
          .map(part => ({
            ...part,
            Scrap: part.Scrap || '',
            User: userName
          }));
      }

      // Sort by customer
      parts.sort((a, b) => (a.Type || '').localeCompare(b.Type || ''));

      console.log(parts);


      setAllParts(parts); // Now an object: { Flex: [...], Rigid: [...], ... }
    };

    if (partDataset.length > 0) initializeParts();
  }, [partDataset, userName]);

  useEffect(() => {
    console.log(allParts);
    const filtered = allParts.filter(part =>
      (filterText.customer === '' || part.Customer?.toLowerCase().includes(filterText.customer.toLowerCase())) &&
      (filterText.desc === '' || part.Part_internalNo?.toLowerCase().includes(filterText.desc.toLowerCase()))
    );
    setfilteredParts(filtered);
  }, [filterText, allParts]);
  useEffect(() => {
    localStorage.setItem('ScrapunsavedPartsData', JSON.stringify(allParts));
  }, [allParts]);

  const [changedLine, setChangedLine] = useState(new Set());

  const handleInputChange = (e, index, key) => {
    const { value } = e.target;
    updateDatas(allParts[index], key, value);
  };

  const updateDatas = (partObj, key, value) => {
    setAllParts(prev => {
      const updatedParts = prev.map(row =>
        row.Part_internalNo === partObj.Part_internalNo ? { ...row, [key]: value } : row
      );

      return updatedParts;
    });

    setChangedLine(prev => new Set(prev).add(partObj.Part_internalNo));
  };
  const partfilters = {
    Start_date: Postartdate,
    End_date: Poenddate,
    Customer: filterText.customer,
    Part_Description: filterText.desc,
    token: token
  }


  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/Scrap/inventory`, { params: partfilters }).then((data) => {
      setScrap_Parts(data.data)

    });
  }, [Postartdate, Poenddate, filterText])


  const Update = () => {
    const changedData_ = allParts
      .filter(part => Number(part.Scrap) > 0)
      .map(part => ({
        ...part,
        Date: Inventory_Date,
      }));

    Axios.post(`https://` + Host + `/Scrap_Inventory/Add`, {
      changedData: JSON.stringify(changedData_),
      token
    })
      .then(res => {
        console.log(res);
        if (res.status === 200) {
          alert(res.data.message);
          localStorage.removeItem('ScrapunsavedPartsData'); // Clear local storage after successful update
          window.location.reload();
          setdel(del + 1);
        } if (res.status === 500) {
          alert(res.data.message);
        }
      })
      .catch(err => console.error(err));
  };

  const ClearAll = () => {
    localStorage.removeItem('ScrapunsavedPartsData');
    Window.alert("Cleared !");
    window.location.reload();
  };

  return (
    <div>
      <div class="row">
        <div class="col">
          <input
            type="text"
            className="form-control"
            placeholder="Filter by Customer"
            onChange={(e) => setFilterText({ ...filterText, customer: e.target.value })}
            list='Customer'
          />
          <datalist id="Customer">
            <option></option>
            {[...new Set(allParts.map(x => x.Customer))].map((Customer, index) => (
              <option key={index}>{Customer}</option>
            ))}
          </datalist>
        </div>
        <div class="col">
          <input
            type="text"
            className="form-control"
            placeholder="Filter by In Internal Part"
            list="PartDescription"
            onChange={(e) => setFilterText({ ...filterText, desc: e.target.value })}
          /> <datalist id="PartDescription">
            <option></option>
            {allParts.map(x => {
              return <option>{x.Part_internalNo}</option>
            })}
          </datalist>
        </div>
        <div className="col">
          <div class="row">

            {/* Grab the Itemicular dates */}
            <input type='date' class="form-control form-rounded" id='supplychain-button' defaultValue={Postartdate} onChange={(e) => {
              setPoStartdate(e.target.value)
            }} />
            <div class="row">
              <input type='date' class="form-control form-rounded" id='supplychain-button' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => { setPoEnddate(e.target.value) }} />
            </div>
          </div>
        </div>
        <div className="col"><button className='btn btn-info' onClick={handlePrint}>Print</button></div>
        <div className="col"><button className='btn btn-primary' onClick={(e) => setHistory(!History)} >Scrap History</button></div>
        <div class="col">
          <button className='btn btn-info' onClick={Update}>Update</button>
          <button className='btn btn-info' onClick={ClearAll}>Clear All</button>
        </div>
      </div>
      <br />

      {History ?
        <div className="inventory_table">
          <input type="date" className="form-control form-rounded" Value={formattedDate} onChange={(e) => setInventory_Date(e.target.value)} />
          <table class="table table-sm table-striped" id="alldata_openorder" ref={tableRef}>

            <thead>

              <tr>
                <th>PART NO</th>
                <th>INTERNAL PART NUMBER</th>
                {AllColumns ? <th>PART DESCRIPTION</th> : null}
                <th>CUSTOMER</th>
                {AllColumns ? <th>CATEGORY</th> : null}
                {AllColumns ? <th>TYPE</th> : null}
                <th>Scrap</th>

              </tr>
            </thead>
            <tbody >
              {filteredParts.map((val) => {
                const realIndex = allParts.findIndex(p => p.Part_internalNo === val.Part_internalNo);
                return (
                  <tr>

                    <td>{val.Part_No}</td>
                    <td>{val.Part_internalNo}</td>
                    {AllColumns ? <td>
                      {val.Part_Description}
                    </td> : null}
                    <td>{val.Customer}</td>
                    {AllColumns ? <td>
                      {val.CATEGORY}
                    </td> : null}
                    {AllColumns ? <td>
                      {val.Type}
                    </td> : null}
                    <td>
                      <input
                        type="number"
                        className="form-control form-rounded"
                        value={val.Scrap || ''}
                        onChange={(e) => handleInputChange(e, realIndex, 'Scrap')}
                      />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>




        :
        <div className="inventory_table">

          <table class="table table-bordered table-striped" id="alldata_openorder" ref={tableRef}>

            <thead>
              <tr>
                <th>DATE</th>
                <th>PART NO</th>
                <th>INTERNAL PART NUMBER</th>
                {AllColumns ? <th>PART DESCRIPTION</th> : null}
                <th>CUSTOMER</th>
                {AllColumns ? <th>TYPE</th> : null}
                <th>Scrap</th>

              </tr>
            </thead>
            <tbody >
              {Scrap_Parts.map((val) => {
                return (
                  <tr>
                    <td>{val.Date.slice(0, 10)}</td>
                    <td>{val.Part_No}</td>
                    <td>{val.Internal_Part_No}</td>
                    {AllColumns ? <td>
                      {val.Part_Description}
                    </td> : null}
                    <td>{val.Customer}</td>
                    {AllColumns ? <td>
                      {val.Type}
                    </td> : null}
                    <td>{val.Scrap}</td>
                  </tr>
                )
              })}
            </tbody>
          </table> </div>
      }

      {printTrigger && (
        <Print
          tableHTML={printTrigger.html}
          user="Vikas"
          title={Area}
          onComplete={() => setPrintTrigger(false)}
        />
      )}</div>
  )
}

export default Scrap;